import * as React from "react";
import type { StrategyStageData } from "@/data/types";

interface Props {
  stage: StrategyStageData;
}

export const StrategyStage: React.FC<Props> = ({ stage }) => {
  return (
    <div
      className="border-t border-charcoal/15 pt-6"
      data-testid={`strategy-stage-${stage.key}`}
    >
      <div className="flex items-baseline gap-4">
        <span className="font-serif text-2xl text-brass md:text-3xl">
          {stage.number}
        </span>
        <h3 className="text-sm font-medium uppercase tracking-[0.2em] text-charcoal">
          {stage.title}
        </h3>
      </div>

      {stage.summary && (
        <p className="mt-4 font-serif text-xl leading-snug text-charcoal md:text-2xl">
          {stage.summary}
        </p>
      )}

      {stage.points?.length > 0 && (
        <ul className="mt-5 space-y-2.5">
          {stage.points.map((p, i) => (
            <li
              key={i}
              className="flex gap-3 text-sm leading-relaxed text-charcoal-soft md:text-base"
            >
              <span aria-hidden className="mt-2 h-1 w-1 shrink-0 rounded-full bg-brass" />
              <span>{p}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
